(() => {
  const script = document.currentScript;
  const section = document.getElementById(script?.dataset.section);
  const target = script?.dataset.defaultSize;
  // Cart edits must restore the customer's saved quantities without defaults.
  if (!section || section.dataset.kmDefaultQuantity ||
      new URLSearchParams(location.search).has('customizer_edit')) return;
  section.dataset.kmDefaultQuantity = 'true';
  const normalize = value => value.trim().toLowerCase()
    .replace(/[–—]/g, '-').replace(/months?$/, 'month');
  const initialize = () => {
    const grid = section.querySelector('.customizer__size-quantity-grid');
    if (!grid) return;
    const inputs = [...grid.querySelectorAll('[data-customizer-size-quantity]')];
    if (!inputs.length) return;
    // Apply once only: later color/size renders and deliberate zeroes are retained.
    observer.disconnect();
    if (inputs.some(input => Number(input.value) > 0)) return;
    const label = [...grid.children].find(label =>
      normalize(label.querySelector('span')?.textContent || '') === target);
    // When no matching specific size exists, use the leftmost available size.
    const input = label?.querySelector('[data-customizer-size-quantity]') ||
      inputs.find(input => !input.disabled);
    if (!input || input.disabled) return;
    input.value = '1';
    // Use the customizer's handler to sync variant selection, totals and cart data.
    input.dispatchEvent(new Event('input', { bubbles: true }));
  };
  const observer = new MutationObserver(initialize);
  observer.observe(section, { childList: true, subtree: true });
  initialize();
})();
